import React, { useState, useEffect } from 'react';
import {ListType, loadItems, searchLoadItem} from '../../apis/dumpert';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Search.css';
import { Loading } from '../loading';
import { AutoSuggestItem } from './';
import {
  selectShowNsfw,
} from '../../ducks';
import { AUTOSUGGESTSEARCH } from '../../lib/labels';

// due to https://github.com/facebook/react/issues/14099
// should be only one instance of this component mounted
// to handle multiple instances use redux state
let mounted = true;
let timeoutId = 0;

export const AutoSuggestSearch = ({ onSelect, inputRef }) => {
  const showNsfw = useSelector(selectShowNsfw);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const getSuggestions = async (isUrl, itemId) => {
    try {
      setIsLoading(true);
      const { data } = isUrl 
        ? await searchLoadItem(itemId)
        : await loadItems({ type: ListType.zoek, nsfw: showNsfw, params: { tagId: inputValue, sorting: 'kudos' } });
      const videoItems = data.items
        .filter(item => item.media[0].mediatype === 'VIDEO')
        .sort((a, b) => { return b.stats.kudos_total - a.stats.kudos_total; });
      if (videoItems.length > 0) { 
        setSuggestions(videoItems); 
        setNoResults(false);
      } else {
        setSuggestions([]); 
        setNoResults(true);
      }
    } finally {
      if (mounted) {
        setIsLoading(false);
      }
    }
  };

  const removeInput = () => {
    setInputValue('');
    setSuggestions([]);
  };

  useEffect(() => {
    const { current } = inputRef;
    current.focus();

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (inputValue.length === 0) {
      setSuggestions([]);
      setNoResults(false);
    }    
    if (inputValue.length > 2 && !inputValue.startsWith('http')) {
      timeoutId = setTimeout(getSuggestions(false), 500);
    }
    if (inputValue.length > 3 && inputValue.startsWith('http')) {
      const getIdFromUrl = () => {
        const urlPartials = inputValue.split('/');
        if (inputValue.includes('legacy')) { return `${urlPartials[4]}_${urlPartials[5]}`; }
        if (inputValue.includes('/item/')) { return urlPartials[4]; }
        if (inputValue.includes('?selectedId')) { return urlPartials[urlPartials.length - 1].split('=')[1]; }
      };
      if (getIdFromUrl()) { timeoutId = setTimeout(getSuggestions(true, getIdFromUrl()), 500); }
    }    
  }, [inputValue, showNsfw]);

  useEffect(() => {
    mounted = true;
    return () => {
      clearTimeout(timeoutId);
      mounted = false;
    };
  }, []);

  return (
    <>
      <h3>{AUTOSUGGESTSEARCH.TITLE}</h3>
      <div className={styles.auto_search}>
        <input
          type="text"
          onChange={({ target: { value } }) => setInputValue(value)}
          autoComplete="off"
          value={inputValue}
          className={'searchfield'}
          ref={inputRef}
          placeholder={AUTOSUGGESTSEARCH.PLACEHOLDER}
        />
        {inputValue.length > 0 && (
          <div
            className={styles.search_remove}
            onClick={removeInput}
          >
            <FontAwesomeIcon icon={['fas', 'times']} size="lg" />
          </div>
        )} 

        {isLoading && <Loading />}
        {(!isLoading && suggestions.length > 0) && 
          <div className={styles.suggested}>
            {suggestions.map((item, index) => 
              <AutoSuggestItem 
                key={`suggestItem-${index}`} 
                item={item} 
                onSelect={onSelect}
                removeInput={removeInput}
              />, 
            )}
          </div>
        }
        {(!isLoading && noResults) && 
          <div className={styles.suggested}>
            <h2>{AUTOSUGGESTSEARCH.NO_RESULTS.TITLE}</h2>
            <p>{AUTOSUGGESTSEARCH.NO_RESULTS.PARAGRAPH}</p>
          </div>
        }      
      </div>
    </>
  );
};